var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCard = function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.018 1.5h15.964c.551 0 .998.447.998.998v10.9a1 1 0 0 1-.998.999H2.018a1 1 0 0 1-.998-.998V2.498m.998-.998a1 1 0 0 0-.998.998m.998-.998a1 1 0 0 0-.998.998m.998-.998H5.32m-4.3.998V5.82M19 10.076V13.4a1 1 0 0 1-.998.998H14.68M19 5.82V2.498a1 1 0 0 0-.998-.998H14.66h.02M5.32 14.397H1.998A1 1 0 0 1 1 13.399v-3.323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 10h17v1h-17z"
  })));
};
export default SvgCreditCard;